import http from '@/utils/http'

//单科考试 - 班级报告 - 班级基础成绩分析
export const getExamClassTeachList_2 = (params) => http.get(`/marking-exam-manager/exam_class/teach-class-list/exam-id/${params.examId}/school-id/${params.schoolId}`) // 获取带权限的教学班考试班级

//单科考试 - 班级报告 - 知识能力分析
export const classStatCompare_2 = (params) => http.post('/marking-statistics-report/kqa/one/school/teach/class', params)//班级各得分情况对比（弹框）

//单科考试 - 班级报告 - 成绩单
export const studentExamWeakPoint_2 = (params) => http.get('/marking-report/report/teach/exam/student/weak/point', params)//查询学生累计薄弱知识点情况

//单科考试 - 班级报告 - 试卷讲评
export const getStudentDetail_2 = (params) => http.get('/marking-report/report/teach/getStudQues', params, 'form')// 获取学生作答


//单科考试 - 校级报告 - 自定义分析
export const setSchoolGroup_2 = (params) => http.post('/marking-statistics/exam-config/custom/teach/class/group?examId=' + params.examId + '&schoolId=' + params.schoolId, params.list)//添加分组分析

// 校级报告 单科
export const getGradeKnowledgePointList_2 = (params) => http.get('/marking-report/report/teach/exam/grade/statistics/pointInfo', params) // 年级知识点得分详细
export const getGradeQuestionScoreList_2 = (params) => http.get('/marking-report/report/teach/exam/grade/question/score', params) // 基础指标趋势
export const classQuesAnalysis_2 = (params) => http.get('/marking-report/report/teach/exam/class/question/analysis', params, 'form') // 班级逐题分析
export const studentQuesAnalysis_2 = (params) => http.get('/marking-report/report/teach/exam/student/question/analysis', params, 'form') // 学生逐题分析

